import Vue from 'vue';
export default Vue.extend({
    props: {
        color: { type: String, required: true },
        icon: { type: String, default: undefined },
        invert: { type: Boolean, default: false },
        name: { type: String, required: true },
        removable: { type: Boolean, default: false },
    },
    data() {
        return {
            hover: false
        };
    },
    computed: {
        text() {
            if (this.removable && this.hover) {
                return 'Remove';
            }
            return this.name;
        }
    },
    updated() {
        this.$nextTick(() => {
            if (!this.removable)
                return;
            const bb = this.$el.getBoundingClientRect();
            if (bb.width > 0) {
                // Set the min width of the label according
                // to its initial content. This prevents it
                // abruptly resizing when showing the Remove
                // hover
                this.$el.style.minWidth = `${bb.width}px`;
            }
        });
    },
    methods: {
        remove(event) {
            if (this.removable) {
                this.$emit('remove');
                event.stopPropagation();
            }
        }
    }
});
